import { VueReCaptcha } from 'vue-recaptcha-v3';

export default defineNuxtPlugin((nuxtApp) => {
    const config = useRuntimeConfig();
    const key = config.public.RECAPTCHA_SITE_KEY as string
    nuxtApp.vueApp.use(VueReCaptcha, {
        siteKey: key,
        loaderOptions: {
            autoHideBadge: true,
            explicitRenderParameters: {
                badge: 'bottomright',
            },
        },
    });
});